import { useEffect, useState } from 'react';

function useSessionFilters<T>(key: string, initialState: T) {
  const [filters, setFilters] = useState<T>(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialState;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return initialState;
    }
  });

  useEffect(() => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(filters));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [key, filters]);

  return [filters, setFilters] as const;
}

export default useSessionFilters;
